import Typography from '@mui/material/Typography'
import {styled} from '@mui/material/styles'

const PaddedTypography = styled(Typography)(({theme}) => ({
  paddingBottom: 5,
  paddingTop: 5,
}))

export default PaddedTypography
